import { newReferralFormFields } from '.';

function newReferralFormFieldsAsServices() {
  return newReferralFormFields('services[]');
}

export default newReferralFormFieldsAsServices;
